import Vue from 'vue'
import Vuex from 'vuex'
import axios from '../axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    docs: null, // object
    test: 'test'
  },
  getters: {
    docs: (state) => {
      return state.docs
    }
  },
  mutations: {
    get_doc: (state, payload) => {
      let docsMap = {}
      for (let i in payload.query) {
        let doc = payload.query[i]
        docsMap[doc.doc_id] = doc.doc_name
      }
      state.docs = docsMap
    },
    rename_doc: (state, payload) => {
      let docId = payload.id
      state.docs[docId] = payload.name
    }
  },
  actions: {
    get_docs: (context) => {
      axios.get('http://801s121.mars-t.mars-hosting.com/test_api/docs')
        .then((response) => {
          context.commit('get_doc', response.data)
        })
        .catch((response) => {
          console.error('Error in get_docs')
        })
    },
    rename_doc: (context, payload) => {
      console.log('ACTION', this.$http)
      context.commit('rename_doc', payload)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js